// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"livestream-event-CourseResources__wrapper--2254M"};